import { __assign } from "tslib";
import { useEffect } from 'react';
import { getActiveFeatures } from '../../utils';
export var useMovrStatus = function (layout, state, setState) {
  useEffect(function () {
    if (getActiveFeatures(layout.features, "movr_In_maintenance", false)) {
      setState(function (prevState) {
        return __assign(__assign({}, prevState), {
          showBanner: true,
          movrWebStatus: 'InMaintenance'
        });
      });
      return;
    }
    var assistanceProgramSummary = ((layout === null || layout === void 0 ? void 0 : layout.currentLoan) || {}).assistanceProgramSummary;
    if (!!(assistanceProgramSummary === null || assistanceProgramSummary === void 0 ? void 0 : assistanceProgramSummary.length)) {
      var assistProgramSummary_1 = assistanceProgramSummary.find(function (x) {
        return x.movrWebStatus;
      });
      setState(function (prevState) {
        return __assign(__assign({}, prevState), {
          showBanner: !assistProgramSummary_1 ? false : !((assistanceProgramSummary === null || assistanceProgramSummary === void 0 ? void 0 : assistanceProgramSummary.movrWebStatus) !== null && (assistProgramSummary_1 === null || assistProgramSummary_1 === void 0 ? void 0 : assistProgramSummary_1.movrWebStatus) === 'NoBanner'),
          movrWebStatus: (assistProgramSummary_1 === null || assistProgramSummary_1 === void 0 ? void 0 : assistProgramSummary_1.movrWebStatus) || 'Default'
        });
      });
      return;
    }
  }, [layout.currentLoan, layout.features]);
};